import React from 'react';
import type { HearOurMembersSliceProps } from '@ww-digital/web-palette-react/dist/components/Slice/HearOurMembersSlice/HearOurMembersSlice';

import { HearOurMembersSlice } from '@ww-digital/web-palette-react/dist/components/Slice/HearOurMembersSlice/HearOurMembersSlice';

interface HearOurMembersSliceContainerProps {
  daCategory: string;
  slice: HearOurMembersSliceProps;
}

export const HearOurMembersSliceContainer = ({
  slice,
}: HearOurMembersSliceContainerProps): JSX.Element => {
  const sliceContainer = <HearOurMembersSlice {...slice} />;

  return <div>{sliceContainer}</div>;
};
